namespace TabAurous.Inventory {
    export namespace SKUSplittingItemsService {
        export const baseUrl = 'Inventory/SKUSplittingItems';

        export declare function Create(request: Serenity.SaveRequest<SKUSplittingItemsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<SKUSplittingItemsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<SKUSplittingItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<SKUSplittingItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GetSKUDetails(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<SKUSplittingItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Inventory/SKUSplittingItems/Create",
            Update = "Inventory/SKUSplittingItems/Update",
            Delete = "Inventory/SKUSplittingItems/Delete",
            Retrieve = "Inventory/SKUSplittingItems/Retrieve",
            List = "Inventory/SKUSplittingItems/List",
            GetSKUDetails = "Inventory/SKUSplittingItems/GetSKUDetails"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'GetSKUDetails'
        ].forEach(x => {
            (<any>SKUSplittingItemsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
